import { AnyAction, Dispatch } from "@reduxjs/toolkit";
import { Editor } from "grapesjs";
import { CustomComponentSettingsFunction } from ".";
import { setGlobalProductPopupElement } from "../features/popupSlice";

import PopupWrapper from "../components/PopupWrapper";
import ProductManageForm from "../components/ProductManageForm";
import { jsonParseSafe } from "../utils";

export const threeBannerProductsConfig: CustomComponentSettingsFunction = (
	editor: Editor,
	type: string,
	content?: string,
	settings?: { data: any; setData: (data: any) => void },
	extraData?: {
		dispatch?: Dispatch<AnyAction>;
	}
) => {
	editor.Components.addType(type, {
		model: {
			defaults: {
				tagName: "div",
				draggable: true,
				droppable: true,
				// Define traits (settings) here
				traits: [
					{
						type: "text", // Type of trait (input)
						label: "Title", // Label for the trait
						name: "titleText", // Name of the trait (used to get/set value)
						changeProp: true,
					},
					{
						type: "button",
						label: "Add Products",
						name: "button",
						text: "Add Products",
						command(editor, trait) {
							console.log("Button clicked", {
								editor,
								trait,
							});

							settings?.setData({
								...settings.data,
								button: "Button Clicked",
							});

							let logical: any;
							let custom: any;

							const selectedComponent = editor.getSelected();
							if (selectedComponent) {
								const customData = jsonParseSafe(
									selectedComponent.getAttributes()[
										"data-custom"
									]
								);

								logical = customData?.logical;
								custom = customData?.custom;
							}

							// Dispatch an action to update the store
							extraData?.dispatch?.(
								setGlobalProductPopupElement(
									<PopupWrapper
										onClose={() => {
											extraData?.dispatch?.(
												setGlobalProductPopupElement(
													null
												)
											);
										}}>
										<ProductManageForm
											title="Manage Left Slider Products"
											logical={logical}
											custom={custom}
											onUpdate={(logical, custom) => {
												// setProducts({
												// 	logical:
												// 		logical || undefined,
												// 	custom: custom || [],
												// });

												const selectedComponent =
													editor.getSelected();
												if (selectedComponent) {
													selectedComponent.setAttributes(
														{
															"data-custom":
																JSON.stringify({
																	logical,
																	custom,
																}),
														}
													);
												}

												extraData?.dispatch?.(
													setGlobalProductPopupElement(
														null
													)
												);
											}}
										/>
									</PopupWrapper>
								)
							);
						},
					},
					{
						type: "text",
						label: "Search",
						name: "search",
						placeholder: "Search...",
						changeProp: false,
						value: "Product",
						command(editor, trait) {
							console.log("Search clicked", {
								editor,
								trait,
							});
						},
					},
				],
				// Define the initial content or data for the component
				// content: data.content,
			},
			init() {
				// this.on("change:titleText", this.handleCustomTextChange);
				this.listenTo(
					this,
					"change:titleText",
					this.handleCustomTextChange
				);
			},
			handleCustomTextChange() {
				const newValue = this.get("titleText");
				// this.set("content", newValue); // Update the content dynamically based on the trait value
				console.log("newValue", newValue);
			},
		},
		view: {
			// Define how the component should render in the canvas
			onRender({ model }) {
				const _content = model.get("content");
				this.el.innerHTML =
					_content || content || "This is a custom component";
			},
		},
	});
};

export default () => <></>;
